import { smoothScrollTo, tryParseJSON } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class Results {

    constructor(element, options) {

        const settings = {
            loader: null, 
            initAttr: 'data-results', 
            contentAttr: 'content', 
            prevAttr: 'prev', 
            nextAttr: 'next', 
            pagerAttr: 'pager', 
            pageselectAttr: 'pageselect',
            pageCountAttr: 'data-resultpages',
            uriAttr: 'data-href'
        };

        this.settings = Object.assign({}, settings, options);

        this.$results = element;
        this.$resultsContent = this.$results.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');

        this.$pager = this.$results.querySelector('[' + this.settings.initAttr + '="' + this.settings.pagerAttr + '"]');
        this.$pageSelect = this.$results.querySelector('[' + this.settings.initAttr + '="' + this.settings.pageselectAttr + '"]');
        this.$prevButton = this.$results.querySelector('[' + this.settings.initAttr + '="' + this.settings.prevAttr + '"]');
        this.$nextButton = this.$results.querySelector('[' + this.settings.initAttr + '="' + this.settings.nextAttr + '"]');

        if(this.$resultsContent !== null && this.$pager !== null && this.$pageSelect !== null && this.$prevButton !== null && this.$nextButton !== null && this.pageUri !== '') {
            this.initialize();
        }
    }

    initialize() {

        this.currentPage = 1;
        this.pageUri = this.$pager.getAttribute(this.settings.uriAttr);
        this.pagesCount = this.$pageSelect.getAttribute(this.settings.pageCountAttr);

        this.setEvents();
    }

    setEvents() {

        this.$prevButton.addEventListener('click', (e) => {
            
            if(this.currentPage > 1) {
                this.setPage(this.currentPage - 1);
            }
            e.preventDefault();
        });

        this.$nextButton.addEventListener('click', (e) => {

            if(this.currentPage < this.pagesCount) {
                this.setPage(this.currentPage + 1);
            }
            e.preventDefault();
        });

        this.$pageSelect.addEventListener('change', (e) => {

            this.setPage(parseInt(this.$pageSelect.value));
            e.preventDefault();
        });
    }

    setPage(i) {

        this.currentPage = i;

        this.$pageSelect.value = this.currentPage;

        if(this.currentPage > 1) {
            this.$prevButton.classList.remove('is--disabled');
        } else {
            this.$prevButton.classList.add('is--disabled');
        }

        if(this.currentPage < this.pagesCount) {
            this.$nextButton.classList.remove('is--disabled');
        } else {
            this.$nextButton.classList.add('is--disabled');
        }

        let uri = this.pageUri.replace('-page-', this.currentPage);

        if(this.settings.loader !== null) {
            const $loader = _createElementFromHTML(this.settings.loader);
            this.$resultsContent.appendChild($loader);
        }

        new AjaxLoad(uri, { 
            onSuccess: (resultText) => {
                
                const result = tryParseJSON(resultText);

                this.$resultsContent.classList.add('is--hidden');

                smoothScrollTo(0, this.$results.offsetTop, 250);

                window.setTimeout(() => {

                    this.$resultsContent.innerHTML = result.template;

                    this.$resultsContent.classList.remove('is--hidden');

                    if(typeof this.settings.onLoaded === 'function') {
                        this.settings.onLoaded(this.$resultsContent);
                    }
                }, 500);
            }
        });
    }
}

export { Results };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const context = eventDetails.$context;

    console.log('results');
    if (context) {
        const $$results = context.querySelectorAll('[data-results="root"]');
        for (let i = 0; i < $$results.length; i++) {
            const $results = $$results[i];

            const resultsAPI = new Results($results);
            $results.resultsAPI = resultsAPI;
        }
    }
});
